{
  "_meta": {
    "_comment": "Phase 18 Wave 6 Task 34 — admin Vendor Detail > Integration tab. vg-binding: P18.D-21 | vg-binding: P18.D-28 | vg-binding: PLAN:task-34 || Phase 18 Wave 7 Task 36 — the ops.* subtree is the FLEET health widget on the vendors list (IntegrationHealthWidget.tsx). vg-binding: P18.D-13 | vg-binding: P18.D-35 | vg-binding: PLAN:task-36",
    "locale": "vi"
  },
  "tab": {
    "title": "Tích hợp",
    "description": "API key, endpoint webhook và nhật ký gửi cho luồng máy của nhà cung cấp này."
  },
  "gate": {
    "heading": "Luồng máy",
    "statusLabel": "Trạng thái thực tế",
    "effectiveOn": "Key gọi được API",
    "effectiveOff": "Mọi lệnh gọi bị từ chối",
    "blockedLane": "Công tắc API vendor toàn hệ thống đang tắt nên mọi nhà cung cấp đều bị từ chối, bất kể công tắc này.",
    "blockedVendor": "Tích hợp của nhà cung cấp này đang tắt nên key của họ bị từ chối, trong khi luồng vẫn mở cho những vendor khác.",
    "laneLabel": "Luồng toàn hệ thống",
    "vendorLabel": "Nhà cung cấp này",
    "on": "Bật",
    "off": "Tắt",
    "toggleOn": "Bật tích hợp",
    "toggleOff": "Tắt tích hợp",
    "toggling": "Đang lưu…",
    "successOn": "Đã bật tích hợp",
    "successOff": "Đã tắt tích hợp",
    "error": "Không đổi được công tắc tích hợp",
    "readOnly": "Bạn xem được tích hợp của nhà cung cấp này, nhưng muốn thay đổi thì cần quyền quản lý nhà cung cấp."
  },
  "keys": {
    "title": "API Key",
    "description": "Các key nhà cung cấp dùng để gọi Vendor API. Key đã thu hồi vẫn nằm trong danh sách để tra cứu hỗ trợ.",
    "create": "Tạo API key",
    "creating": "Đang tạo…",
    "empty": "Nhà cung cấp này chưa có API key nào.",
    "labelLabel": "Nhãn key",
    "labelPlaceholder": "ví dụ: hệ thống sản xuất",
    "labelRequired": "Nhập nhãn trước khi tạo key.",
    "columns": {
      "key": "Key",
      "created": "Ngày tạo",
      "lastUsed": "Dùng lần cuối",
      "createdBy": "Người tạo",
      "status": "Trạng thái",
      "actions": "Thao tác"
    },
    "status": {
      "active": "Đang hoạt động",
      "revoked": "Đã thu hồi"
    },
    "role": {
      "vendor_owner": "Chủ nhà cung cấp",
      "admin": "Quản trị viên"
    },
    "never": "Chưa dùng",
    "revoke": "Thu hồi",
    "revoking": "Đang thu hồi…",
    "confirm": {
      "title": "Thu hồi API key này?",
      "description": "Key ngừng hoạt động ngay lập tức và chủ nhà cung cấp sẽ nhận thông báo. Không thể hoàn tác.",
      "confirmLabel": "Thu hồi key"
    },
    "created": {
      "title": "Đã tạo API key",
      "description": "Sao chép ngay — key chỉ hiện đúng một lần và không đọc lại được.",
      "warning": "Key này chỉ hiện một lần. Hãy lưu giữ an toàn.",
      "copy": "Sao chép",
      "copied": "Đã sao chép",
      "copyFailed": "Sao chép thất bại — hãy bôi đen đoạn key và tự sao chép.",
      "saved": "Tôi đã lưu key này",
      "done": "Xong"
    },
    "toast": {
      "createdTitle": "Đã tạo API key",
      "createdBody": "Sao chép key trước khi rời khỏi khung này.",
      "revokedTitle": "Đã thu hồi API key",
      "revokedBody": "Key không còn xác thực được nữa.",
      "errorTitle": "Thao tác với key thất bại"
    }
  },
  "webhook": {
    "title": "Endpoint webhook",
    "description": "Nơi nhà cung cấp này nhận dữ liệu sự kiện.",
    "urlLabel": "URL webhook",
    "noUrl": "Chưa đăng ký endpoint nào.",
    "statusLabel": "Trạng thái",
    "status": {
      "unset": "Chưa đặt",
      "unverified": "Chưa xác minh",
      "verified": "Đã xác minh",
      "auto_disabled": "Bị tự động tắt"
    },
    "verifiedAtLabel": "Xác minh lúc",
    "failuresLabel": "Số lần lỗi liên tiếp",
    "vendorOnlyNote": "URL và khoá ký do nhà cung cấp tự đổi trong cổng của họ; quản trị viên chỉ đọc ở đây."
  },
  "deliveries": {
    "title": "Nhật ký gửi",
    "description": "Các lần gửi webhook cho nhà cung cấp này, mới nhất trước.",
    "filterLabel": "Trạng thái",
    "filterAll": "Tất cả trạng thái",
    "status": {
      "delivered": "Đã gửi",
      "retrying": "Đang thử lại",
      "failed": "Thất bại",
      "suppressed": "Bị chặn"
    },
    "columns": {
      "event": "Sự kiện",
      "status": "Trạng thái",
      "attempts": "Số lần thử",
      "lastAttempt": "Lần thử cuối",
      "response": "Phản hồi"
    },
    "empty": "Chưa ghi nhận lần gửi nào.",
    "previous": "Trước",
    "next": "Sau",
    "attemptsValue": "{{attempt}} / {{max}}",
    "noResponse": "Không có phản hồi",
    "refreshing": "Đang làm mới…",
    "showing": "Đang hiển thị {{count}} lần gửi"
  },
  "ops": {
    "title": "Sức khoẻ tích hợp",
    "description": "Tình hình gửi webhook cho toàn bộ vendor trong {{hours}} giờ qua.",
    "loading": "Đang tải dữ liệu sức khoẻ tích hợp…",
    "loadFailed": "Không tải được dữ liệu sức khoẻ tích hợp: {{message}}",
    "retry": "Thử lại",
    "refreshing": "Đang làm mới…",
    "generatedAt": "Số liệu lúc {{time}}",
    "lane": {
      "label": "Luồng gửi ra",
      "on": "Đang gửi",
      "off": "Đang ngừng gửi",
      "lane_disabled": "Công tắc khẩn cấp của Vendor API đang tắt. Hệ thống không gửi gì và mọi lần gửi ghi nhận là suppressed đều bị chặn có chủ đích — đây không phải sự cố.",
      "dispatch_lane_off": "Cờ gửi webhook ra ngoài đang tắt. Hệ thống không gửi gì và mọi lần gửi ghi nhận là suppressed đều bị chặn có chủ đích — đây không phải sự cố."
    },
    "events": {
      "failedLabel": "Sự kiện hỏng ({{hours}}h)",
      "ofSettled": "trên {{settled}} sự kiện đã ngã ngũ",
      "delivered": "Đã gửi được",
      "retrying": "Đang thử lại",
      "suppressed": "Bị chặn có chủ đích",
      "suppressedNote": "Mỗi sự kiện chỉ tính một lần, dù phải thử lại bao nhiêu lần. Lần gửi bị chặn bởi công tắc không bao giờ bị tính là hỏng."
    },
    "vendors": {
      "label": "Vendor đang hỏng",
      "value": "{{failing}} trên {{active}}"
    },
    "endpoints": {
      "label": "Endpoint bị tự động tắt",
      "value": "{{count}} trên {{total}}",
      "vendors": "thuộc {{count}} vendor"
    },
    "queue": {
      "label": "Hàng đợi gửi",
      "value": "{{waiting}} chờ · {{active}} đang chạy · {{delayed}} hoãn",
      "unreachable": "Không đọc được hàng đợi",
      "paused": "Hàng đợi đang tạm dừng"
    },
    "alert": {
      "warning": "Cảnh báo toàn hệ thống",
      "critical": "Sự cố toàn hệ thống",
      "hint": "Hỏng trên diện rộng thường là do phía mình — hãy kiểm tra worker gửi webhook, khoá ký (signing key) và DNS/TLS đi ra trước khi liên hệ vendor.",
      "notified": "Đã gửi một thông báo cho admin về việc này.",
      "reason": {
        "fleet_failure_rate": "{{vendors}} vendor cùng hỏng một lúc — {{observed}} số sự kiện đã ngã ngũ bị hỏng, vượt ngưỡng {{threshold}}.",
        "auto_disable_spike": "{{observed}} endpoint bị tự động tắt thuộc {{vendors}} vendor, vượt ngưỡng {{threshold}}."
      }
    }
  },
  "errors": {
    "loadFailed": "Không tải được dữ liệu tích hợp: {{message}}",
    "retry": "Thử lại"
  },
  "common": {
    "loading": "Đang tải…"
  }
}
